import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import { DispatchParamList } from '../../../typings/Params';
import ActingBodiesDropdown from '../OccurrenceTypes/ActingBodiesDropdown';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { HandcuffReasonType, handcuffReasonTypes } from '../../../schemas/dispatch';

interface Props {
    filters: DispatchParamList['HandcuffReasons'];
    setFilters: React.Dispatch<React.SetStateAction<DispatchParamList['HandcuffReasons']>>;
    canFilterActingBody?: boolean;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ canFilterActingBody, filters, setFilters, textFilter, setTextFilter }: Props) {
    const navigation = useNavigation<NavigationProp<RouteProp<DispatchParamList, 'HandcuffReasons'>>>();

    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);
    const [type, setType] = useState<HandcuffReasonType | 'ALL'>(filters.type ?? 'ALL');

    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
        setType('ALL');
    };

    const handleFilter = () => {
        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            type: type !== 'ALL' ? type : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });

        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            type: type !== 'ALL' ? type : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('typeToSearch')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            <FilterDropdown
                label={translate('type')}
                items={['ALL', ...handcuffReasonTypes].map((value) => ({
                    label: translate(value),
                    value: value
                }))}
                multiple={false}
                setValue={setType}
                value={type}
                zIndex={2}
                disabled={false}
                labelFontSize={16}
            />
            {canFilterActingBody && <ActingBodiesDropdown includeAllOption={true} value={actingBodyId} setValue={setActingBodyId} zIndex={1} />}
        </Filters>
    );
}


export default Filter;
